// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__7QkGp","right":"Footer_right__1lJP5","buttons":"Footer_buttons__1feZO"};